/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DOCUMENT, Component, Inject, OnInit} from '@angular/core';

import {ApiConfig} from '../../components/api/api';
import template from './welcome-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-welcome-page',
  template
})
export class WelcomePageComponent implements OnInit {
  readonly showMailingList = ApiConfig.obtain().getEnv() !== 'localhost';

  constructor(@Inject(DOCUMENT) private readonly document: any) {
  }

  ngOnInit(): void {
    if (!this.showMailingList) {
      return;
    }
    const scriptId = 'hs-forms-embed';
    if (!this.document.getElementById(scriptId)) {
      const script = this.document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js-eu1.hsforms.net/forms/embed/147239819.js';
      this.document.body.appendChild(script);
    }
  }
}
